module.exports = __webpack_public_path__ + "img/Jclubs.2a8653c0.jpg";